export default {"src":"/_next/static/media/top.279115a1.svg","height":159,"width":293,"blurWidth":0,"blurHeight":0};